export default __webpack_public_path__ + "static/media/dropbox-icon.a6614224.png";